import { render } from "./CardWishlist.vue?vue&type=template&id=a9a908d4"
import script from "./CardWishlist.vue?vue&type=script&lang=js"
export * from "./CardWishlist.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__